<template>
  <div class="tags-box">
    <el-dialog :title="'标签编辑'" :visible.sync="dialogVisible" width="550px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="editParam" label-width="100px">
        <el-form-item label="标签:" prop="tags">
          <tag-selector
            v-model="editParam.tags"
            :tagList="tagList"
          ></tag-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitTag" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import TagSelector from "@/components/tagSelector";

export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      dialogVisible: false,
      tagList: [],
      editParam: {
        ids: [],
        tags: [],
      },
    }
  },
  methods: {
    // 打开弹窗并赋值需要修改
    open(videoIds) {
      this.getTagList();
      this.dialogVisible = true
      this.editParam.ids = videoIds || [];
    },
    getTagList() {
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    // 提交tags
    submitTag() {
      const tags = this.editParam.tags.filter(
            (item) => this.tagList.map((e) => e.name).indexOf(item) === -1
          );
          if (tags.length > 0) {
            this.$confirm(
              `标签${tags.join(",")}不属于常用标签，确定修改？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.editTags();
              })
              .catch(() => {
                return false;
              });
          } else {
            this.editTags();
          }
    },
    editTags() {
      if (!this.editParam.tags.length) return this.$message.error('请至少选择一个标签');
      API.batchEditTags(this.editParam).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          });
          this.$emit("handlerClose")
        } else {
          this.$message.error('编辑失败！');
        }
        this.handleClose()
      }).catch(() => {
        this.handleClose()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tags-box {
  .input-box {
    margin-top: 15px;
    text-align: left;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
}
</style>
